import { type SxProps, type Theme } from '@mui/material'

export const defaultSx = {
  width: '750px',
  display: 'flex',
  '& .MuiFilledInput-root': {
    backgroundColor: 'var(--grey-100)',
    '&:hover': {
      backgroundColor: 'var(--grey-100)'
    },
    '&.Mui-focused': {
      backgroundColor: 'var(--grey-100)'
    }
  }
} satisfies SxProps<Theme>
